<template>
    <f7-toolbar
        tabbar
        bottom
        labels
        class="mainTabbar nowide"
    >

        <a
            :class="`link ${currentTab === 'home' ? 'tab-link-active' : ''}`"
            href="#"
            data-animate="false"
            @click="setTab('home', '/home')"
        >
            <i class="icon">
                <svg
                    width="510px"
                    height="510px"
                    viewBox="0 0 510 510"
                    xml:space="preserve"
                    style="width: 28px; height: 32px;"
                >
                    <g>
                        <polygon points="204,471.75 204,318.75 306,318.75 306,471.75 433.5,471.75 433.5,267.75 510,267.75 255,38.25 0,267.75 76.5,267.75 76.5,471.75" />
                    </g>
                </svg>
            </i> <span>Home</span>
        </a>
        <a
            v-if="[5].indexOf(variant) > -1"
            :class="`link ${currentTab === 'goals' ? 'tab-link-active' : ''}`"
            href="#"
            data-animate="false"
            @click="setTab('goals', '/goals')"
        >
            <i class="icon">

                <svg
                    style="width: 30px; height: 32px;"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 32 32"
                    xml:space="preserve"
                >
                    <path d="M30.9,5.6C30.8,5.2,30.4,5,30,5h-3V2c0-0.4-0.2-0.8-0.6-0.9C26,0.9,25.6,1,25.3,1.3l-4,4C21.1,5.5,21,5.7,21,6v3.6l-5.7,5.7
	c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l5.7-5.7H26c0.3,0,0.5-0.1,0.7-0.3l4-4C31,6.4,31.1,6,30.9,5.6z" />
                    <path d="M18.1,18.1C17.6,18.7,16.8,19,16,19s-1.6-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l2.8-2.8C16.5,11,16.2,11,16,11
	c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5c0-0.2,0-0.5-0.1-0.7L18.1,18.1z" />
                    <path d="M28.1,12.1C27.6,12.7,26.8,13,26,13h-2.8l-0.7,0.7c0.3,0.7,0.4,1.5,0.4,2.3c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7
	c0.8,0,1.6,0.2,2.3,0.4L19,8.8V6c0-0.8,0.3-1.6,0.9-2.1l1-1C19.3,2.3,17.7,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14
	c0-1.7-0.3-3.3-0.9-4.9L28.1,12.1z" />
                </svg>

            </i> <span>Goals</span>
        </a> <a
            :class="`link ${currentTab === 'explore' ? 'tab-link-active' : ''}`"
            href="#"
            data-animate="false"
            @click="setTab('explore', '/explore/')"
        >
            <i class="icon">
                <svg
                    width="510px"
                    height="510px"
                    viewBox="0 0 510 510"
                    xml:space="preserve"
                    style="width: 26px; height: 32px;"
                >
                    <g>
                        <path d="M255,226.95c-15.3,0-28.05,12.75-28.05,28.05s12.75,28.05,28.05,28.05s28.05-12.75,28.05-28.05S270.3,226.95,255,226.95z M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M311.1,311.1L102,408l96.9-209.1L408,102 L311.1,311.1z" />
                    </g>
                </svg>
            </i> <span>Explore</span>
        </a>
        <a
            :class="`link ${currentTab === 'profile' ? 'tab-link-active' : ''}`"
            href="#"
            data-animate="false"
            @click="setTab('profile', '/profile/')"
        >
            <i class="icon">
                <svg
                    width="408px"
                    height="408px"
                    viewBox="0 0 408 408"
                    xml:space="preserve"
                    style="width: 25px; height: 32px;"
                >
                    <g>
                        <path d="M204,204c56.1,0,102-45.9,102-102S260.1,0,204,0c-56.1,0-102,45.9-102,102S147.9,204,204,204z M204,255 C135.15,255,0,288.15,0,357v51h408v-51C408,288.15,272.85,255,204,255z" />
                    </g>
                </svg>
            </i>
            <span>Me</span>
            <span
                v-if="unreadEventsPlusPulse"
                class="badge color-red"
            >{{ unreadEventsPlusPulse }}</span>
        </a>

    </f7-toolbar>
</template>

<script>
export default {
    props: ['tab'],
    store: ['currentTab', 'unreadEvents', 'onboardingCompleted', 'trackerData'],
    data () {
        return {
            variant: 0,
        };
    },
    computed: {
        unreadEventsPlusPulse: function () {
            return this.unreadEvents + (this.onboardingCompleted > 1 && this.trackerData.timeForTracker ? 1 : 0);
        }
    },
    created: function () {
        this.variant = parseFloat(window.localStore.getItem(`experiment-014_goals`));
    },
    mounted: function () {
        if (pgap && localStore.getItem('notifications')) {
            setTimeout(() => { // invoking native stuff during load can hurt animation
                if (cordova.plugins && cordova.plugins.notification && cordova.plugins.notification.badge) {
                    cordova.plugins.notification.badge.set(this.unreadEventsPlusPulse);
                }
            }, 1000);
        }
    },
    methods: {
        setTab: function (tab, url) {
            this.currentTab = tab;
            f7.views['main'].router.navigate(url, { clearPreviousHistory: true, animate: false });
            if (tab === 'home') {
                $$('.home-scroll  .page-content').scrollTop(0, 400);
            }
            if (tab === 'profile') {
                $$('.profile-scroll .page-content').scrollTop(0, 400);
            }
            if (tab === 'explore') {
                $$('.explore-scroll .page-content').scrollTop(0, 400);
            }
            if (tab === 'goals') {
                $$('.goals-scroll .page-content').scrollTop(0, 400);
            }
            // if (pgap) window.Vibrate.vibrate('light');
            // if (!pgap)
            //     f7.views['main'].router.updateCurrentUrl(`/${tab}`);
            // window.history.pushState("object or string", "Title", `/${tab}`);
        }
    }
};
</script>